import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52fbf6a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "data" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "data" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "data" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('on-select', _ctx.doctor.npi)), ["prevent"])),
    class: _normalizeClass(["user-card", {'select':_ctx.select, 'active': _ctx.doctor.npi === _ctx.selectedDoctor }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$localize('registration.doctor.card.name')), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.doctor.fullName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$localize('registration.doctor.card.location')), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.doctor.location), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$localize('registration.doctor.card.npi')), 1),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.doctor.npi), 1)
    ]),
    (_ctx.doctor.specialties[0]?.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$localize('registration.doctor.card.specialties')), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.doctor.specialties[0].label), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}